"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yellowErrorCodeTypes = exports.statusToTranslation = exports.statusToIcon = exports.redErrorCodeTypes = exports.greenErrorCodeTypes = exports.errorCodeTypes = exports.alarmTypes = exports.StatusIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("@nicbase/types");

var _statusIcon = _interopRequireDefault(require("./status-icon"));

var _statusTranslation = _interopRequireDefault(require("./status-translation"));

var _excluded = ["status"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var statusToTranslation = function statusToTranslation(status) {
  var _statusTranslation$st;

  if (!status) return null;
  return (_statusTranslation$st = _statusTranslation["default"][status]) !== null && _statusTranslation$st !== void 0 ? _statusTranslation$st : null;
};

exports.statusToTranslation = statusToTranslation;

var statusToIcon = function statusToIcon(status) {
  var _statusIcon$status;

  if (!status) return null;
  return (_statusIcon$status = _statusIcon["default"][status]) !== null && _statusIcon$status !== void 0 ? _statusIcon$status : null;
};

exports.statusToIcon = statusToIcon;

var StatusIcon = function StatusIcon(_ref) {
  var status = _ref.status,
      rest = _objectWithoutProperties(_ref, _excluded);

  var icon = statusToIcon(status);

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(icon, rest);
};

exports.StatusIcon = StatusIcon;
StatusIcon.defaultProps = {
  className: null,
  style: null
};
var redErrorCodeTypes = [_types.LatestDataErrorCodeStatusType.CarrierAlert, _types.LatestDataErrorCodeStatusType.CbtAlert, _types.LatestDataErrorCodeStatusType.TkAlert];
exports.redErrorCodeTypes = redErrorCodeTypes;
var yellowErrorCodeTypes = [_types.LatestDataErrorCodeStatusType.CarrierCaution, _types.LatestDataErrorCodeStatusType.CbtCaution, _types.LatestDataErrorCodeStatusType.TkCaution];
exports.yellowErrorCodeTypes = yellowErrorCodeTypes;
var greenErrorCodeTypes = [_types.LatestDataErrorCodeStatusType.CarrierNotification, _types.LatestDataErrorCodeStatusType.CbtNotification, _types.LatestDataErrorCodeStatusType.TkNotification];
exports.greenErrorCodeTypes = greenErrorCodeTypes;
var errorCodeTypes = [].concat(redErrorCodeTypes, yellowErrorCodeTypes, greenErrorCodeTypes);
exports.errorCodeTypes = errorCodeTypes;
var alarmTypes = [_types.LatestDataAlarmStatusType.RedAlarm, _types.LatestDataAlarmStatusType.YellowAlarm, _types.LatestDataAlarmStatusType.GreenAlarm];
exports.alarmTypes = alarmTypes;